import { FC, ReactNode, MouseEvent, createElement } from 'react';
import { track } from 'mod/store/nav/utils';
import { Link } from '@base/lib/Link';
import { INavItem, IClassicItem } from 'mod/store/nav/interface';

type INavLinkProps = {
    className?: string;
    item: INavItem | IClassicItem;
    level?: number;
    target?: string | INavItem | IClassicItem; //ctr 打点 relTarget
    relTarget?: string | INavItem | IClassicItem; //ctr 打点 relTarget
    position: number | string;//ctr 打点 position
    onClick?: (e?: MouseEvent) => void;
    onClose?: () => void;
    onMouseEnter?: (e?: MouseEvent) => void;
    disableTrack?: boolean; //禁止打点
    disableLink?: boolean; //禁止跳转
    children?: ReactNode;
};

export const NavLink: FC<INavLinkProps> = props => {
    const {
        className,
        item,
        level,
        target: propsTarget,
        relTarget,
        position,
        onClick,
        onClose,
        onMouseEnter,
        disableTrack = false,
        disableLink = false,
        children,
    } = props;

    let target = propsTarget || item;
    target = typeof target === 'string' ? target : (target.link || target.title);

    const containerProps = {
        className,
        onMouseEnter,
        'data-t-tar': target,
        'data-t-pos': position,
        tabIndex: 0
    };

    const trackData = {
        target,
        relTarget: relTarget || propsTarget || item,
        position,
    };

    if (!item.link || disableLink) {
        return createElement(
            level === 1 ? 'h3' : 'p',
            {
                ...containerProps,
                onClick: e => {
                    if (!disableTrack) {
                        track(trackData);
                    }
                    onClick?.(e);
                }
            },
            children || item.title)
    }

    return (
        <Link
            {...containerProps}
            href={item.link}
            onClick={e => {
                if (!disableTrack) {
                    track(trackData);
                }
                onClick?.(e);
                onClose?.();
            }}
        >
            {level === 1
                ? <h3>{children || item.title}</h3>
                : children || item.title
            }
        </Link>
    )
};
